<template>
  <BaseChartPanel
    :title="t('regions_stat_bar.title')"
    :date="date"
    :chart-height="stylesChart.heightBarChart"
    :chart-options="chartOptions"
    :series="categories?.length ? series : []"
    @refresh="loadData"
    @update:date="date = $event"
  />
</template>

<script setup>
import { computed } from "vue";
import { useStatRegionsStore } from "@/store/Analytic/chart/stat-regions";
import { useNewsFeedStore } from "@/store/NewsFeed/newsFeed";
import { stylesChart } from "@/tools/tooltipChart";
import useBarChart from "@/mixins/apexChart/barChart";
import { t } from "@/controllerLK/AvalLocalization";
import useFilterDate from "@/mixins/apexChart/filterDate";
import BaseChartPanel from "./BaseChartPanel.vue";

const statStorage = useStatRegionsStore();
const newsStorage = useNewsFeedStore();

const { date } = useFilterDate(loadData);

async function loadData() {
  await statStorage.loadStat(date.value[0], date.value[1]);
}

const allCategories = computed(() => {
  const regions = newsStorage.projectCities;
  if (!regions?.length) return [];
  const sortedItems = (statStorage.items || []).sort((a, b) => b.data - a.data);
  return (sortedItems || []).map((item) => {
    const regionObj = regions.find((reg) => reg.id === item.name);
    return regionObj?.city ? regionObj.city : "No name";
  });
});

const categories = computed(() => allCategories.value.filter((item) => item !== "No name"));

const series = computed(() => {
  const data = (statStorage.items || [])
    .map((item) => item.data)
    .filter((item, index) => (allCategories.value[index] !== "No name"));
  return [{
    name: " ",
    data: data.sort((a, b) => b - a),
    color: "#AB83FF"
  }];
});

const { chartOptions } = useBarChart(
  {
    titleText: t("regions_stat_bar.title"),
  },
  categories,
  series
);
</script>